import type { CreateWhitelabelConfigBody } from "@nlc/shared-types";
import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { whitelabelKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useCreateWhitelabelConfig(): UseMutationResult<
  void,
  Error,
  CreateWhitelabelConfigBody
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateWhitelabelConfigBody) =>
      apiClient.url("/whitelabel/configs").post(data).res(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: whitelabelKeys.all,
      });
    },
  });
}
